import i18n from "utils/i18n";
import { RepositoryFactory } from "repositories/factory";

// import monitoringDevices from "../repositories/modules/monitoring-devices";
import {
  Validator,
  ERROR_TYPE_CD,
} from "./validator";

const ITEM_CODE = {
  ORGANIZATION_ID: "00",
  NAME: "01",
  PRODUCT_KEY: "02",
};

// 名称のデフォルト最大文字数
const MAX_NAME_LENGTH = 20;
const PRODUCT_KEY_LENGTH = 9;

const MabeeemlMonitoringDevicesRepository = RepositoryFactory.get("mabeeeml-monitoring-devices");

class MonitoringDevicesValidator extends Validator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this.errors.organizationId = [];
    this.errors.projectId = [];
    this.errors.monitoringDeviceId = [];

    this.errors.name = [];
    this.errors.productKey = [];
  }
  /* eslint-enable */

  async checkProductKey(key, val, attributeName, itemCd) {
    // 必須チェック
    if (val === "") {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // ９桁の英数字のみ
    if (!Validator.isAlphaNumOnly(val) || val.length !== PRODUCT_KEY_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.productKey", { attribute: attributeName }),
      );
    }

    // 入力フォーマットが有効であれば、プロダクトキーのチェックを行う
    if (this.getErrorMsg(key) === "") {
      // 利用可能な監視デバイス
      const activateStatus
        = await MabeeemlMonitoringDevicesRepository.getActivateStatus(val);
      if (activateStatus.status === "invalid") {
        this.pushValidationResultItem(
          key,
          this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
          "無効な監視デバイスIDです",
        );
      } else if (activateStatus.status === "activated") {
        this.pushValidationResultItem(
          key,
          this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
          "すでに使用されている監視デバイスIDです",
        );
      } else if (activateStatus.status !== "available") {
        this.pushValidationResultItem(
          key,
          this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
          "利用できない監視デバイスIDです",
        );
      }
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }
}

class MonitoringDevicesStoreValidator extends MonitoringDevicesValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static async validate(monitoringDevice) {
    const validator = new MonitoringDevicesStoreValidator();

    // 組織ID
    validator.checkRequired(
      "organizationId",
      monitoringDevice.organizationId,
      "組織ID",
      ITEM_CODE.ORGANIZATION_ID,
    );

    console.log(monitoringDevice.json());

    // 管理名称
    validator.checkName(
      "name",
      monitoringDevice.name,
      "監視デバイスの管理名",
      ITEM_CODE.NAME,
      {
        maxSize: MAX_NAME_LENGTH,
        required: false,
      },
    );

    // 備考欄
    await validator.checkProductKey(
      "productKey",
      monitoringDevice.productKey,
      "監視デバイスID",
      ITEM_CODE.PRODUCT_KEY,
    );

    console.log(validator);
    return validator;
  }
}

class MonitoringDevicesUpdateValidator extends MonitoringDevicesValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static async validate(monitoringTarget) {
    const validator = new MonitoringDevicesStoreValidator();

    // 管理名称
    validator.checkName(
      "name",
      monitoringTarget.name,
      "監視デバイスの管理名",
      ITEM_CODE.NAME,
      {
        maxSize: MAX_NAME_LENGTH,
        required: false,
      },
    );

    return validator;
  }
}

export {
  MonitoringDevicesValidator,
  MonitoringDevicesStoreValidator,
  MonitoringDevicesUpdateValidator,
};
